// extracted by mini-css-extract-plugin
export default {"title":"title___p6q2_"};